import { useEffect } from 'react';
import ScoreService from '../../../../services/score_service';

const formatScoreDate = (value) => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  const day = String(date.getDate()).padStart(2, '0');
  const month = date.toLocaleDateString('es-CO', { month: 'short' }).replace('.', '');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${day} ${month}, ${hours}:${minutes}`;
};

const Score = (vm) => {
  const loadScore = async () => {
    vm.setLoading(true);
    try {
      const scoreObject = await ScoreService.get(vm.userId);
      if (vm.logout(scoreObject)) return;
      vm.setDateUpdate(formatScoreDate(scoreObject?.LastUpdated));
      vm.setScore(scoreObject?.Score || 0);
    } catch (e) {
      vm.message(e?.message || e, "error");
    } finally {
      vm.setLoading(false);
    }
  }

  useEffect(() => {loadScore()}, [vm.userId]);
}

export default Score;
